import {
  getRegistrantAccountOptions,
  getRegistrantAccountUsersQueryKey,
} from "@/hera-api/client/@tanstack/react-query.gen";
import { isHeyApiQuery } from "@/lib/hey-api-query-key";
import type { QueryClient } from "@tanstack/react-query";

export function invalidateRegistrantUserQueries(
  queryClient: QueryClient,
): void {
  void queryClient.invalidateQueries({
    queryKey: getRegistrantAccountUsersQueryKey(),
  });
  void queryClient.invalidateQueries({
    queryKey: getRegistrantAccountOptions().queryKey,
  });
  void queryClient.invalidateQueries({
    predicate: (query) =>
      isHeyApiQuery(query.queryKey, "getRegistrantAccountUser"),
  });
}
